import { render, staticRenderFns } from "./SlotTable.vue?vue&type=template&id=0c134f67&scoped=true"
import script from "./SlotTable.vue?vue&type=script&lang=js"
export * from "./SlotTable.vue?vue&type=script&lang=js"
import style0 from "./SlotTable.vue?vue&type=style&index=0&id=0c134f67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c134f67",
  null
  
)

export default component.exports